import { getEnvVar } from '@mc/client-env'

const getConfigurationVar = (key: string) => {
  const processEnv =
    // eslint-disable-next-line no-process-env
    typeof process !== 'undefined' ? process?.env?.[key] : undefined
  if (typeof processEnv === 'string') {
    return processEnv
  }
  const envVar = getEnvVar(key)
  if (typeof envVar === 'string') {
    return envVar
  }
  return undefined
}

export const getConfig = () => ({
  logLevel: getConfigurationVar('LOG_LEVEL') ?? 'info',
  env:
    getConfigurationVar('APP_TYPE') ??
    getConfigurationVar('ENV') ??
    'development',
})
